import { useCallback, useContext, useEffect, useState } from "react";
import InnerLayout from "../../../components/layouts/inner-layout";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import LoadingSpinner from "../../../components/helper-components/loading-spinner";
import moment from "moment";
import { DataContext } from "../../../components/layouts/main-layout";

import {
  purchaseCreditTableAction,
  purchaseCreditViewAction,
  purchaseCreditVoidAction,
} from "../../../redux/actions/purchase-action";
import { storeDetailsAction } from "../../../redux/actions/invoices-action";
import DynamicTransactionTable from "../../../components/tables/dynamic-transaction-table";
import SalesPurchaseFilter from "../../../components/sales-section/sales-purchase-filter";
import BadgesComponent from "../../../components/tables/badges-component";
import { formatIndianNumber } from "../../../components/helper-components/helper-function";
import {
  ChartColumnIncreasing,
  FileText,
  MoveDownLeft,
  TimerIcon,
} from "lucide-react";
import TransSummaryComp from "../../../components/helper-components/trans-summary-comp";

const PurchaseCreditTable = () => {
  const [billSummary, setBillSummary] = useState({});

  const [heading, setHeading] = useState([]);

  const [showFilter, setShowFilter] = useState(false);
  const { permissionFn } = useContext(DataContext);
  const dispatch = useDispatch();
  const [orders, setOrders] = useState([]);
  const [dataCount, setDataCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [action, setAction] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(null);
  const [invoiceItems, setInvoiceItems] = useState([]);
  const [storeDetails, setStoreDetails] = useState({});
  const [reload, setReload] = useState(false);

  useEffect(() => {
    dispatch(storeDetailsAction(onSuccessStoreDetails, onErrorStoreDetails));
    const data = localStorage.getItem("ModPermission");
    if (data) {
      const parsed = JSON.parse(data);
      const pctnData = parsed.find((obj) => obj?.purchase_credit_note_list);
      if (pctnData?.purchase_credit_note_list) {
        setHeading(pctnData.purchase_credit_note_list);
      }
    }
  }, []);
  const onSuccessStoreDetails = (data) => {
    setStoreDetails(data?.data);
  };
  const onErrorStoreDetails = () => {};
  const [filterData, setFilterData] = useState({
    sort_by: "",
    sort_order: "",
    // selectColumn: "pct_invoice_number",
    selectColumn: "",
    from: "",
    to: "",
    inputValue: "",
    orderStatus: "",
  });

  useEffect(() => {
    dispatch(
      purchaseCreditTableAction(
        {
          pageNumber: currentPage,
          pageSize: pageSize,
          filterData,
        },
        onSuccess,
        onError
      )
    );
  }, [currentPage, pageSize, filterData, reload]);
  const onSuccess = (data) => {
    setError(false);
    setLoading(false);
    setOrders(data?.data?.orderList ?? []);
    setDataCount(data?.data?.totalCount);
    setBillSummary(data?.data?.getOrderStats);
  };
  const onError = (data) => {
    setError(true);
    setLoading(false);
  };
  const navigate = useNavigate();
  const paginationProps = {
    pageSize: pageSize,
    setPageSize: setPageSize,
    dataCount: dataCount,
    setCurrentPage: setCurrentPage,
    currentPage: currentPage,
  };

  const initialFilter = {
    sort_by: "",
    sort_order: "",
    selectColumn: "pct_invoice_number",
    from: "",
    to: "",
    inputValue: "",
    orderStatus: "",
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        action &&
        currentIndex != null &&
        !event.target.closest(".relative")
      ) {
        setAction(false);
        setCurrentIndex(null);
      }
    };
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [action, currentIndex]);

  const tableBodyData = orders?.map((item) => {
    return {
      id: item?.pct_id,
      pct_invoice_number:
        (
          <span className="fw_500 cursor-pointer">
            {item?.pct_invoice_number ?? "--"}
          </span>
        ) ?? "--",
      pct_custom_invoice_number:
        (
          <span className="fw_500 cursor-pointer">
            {item?.pct_custom_invoice_number ?? "--"}
          </span>
        ) ?? "--",
      pct_order_date: moment(item?.pct_order_date).isValid()? moment(item.pct_order_date).format("MMM D, YYYY"): "--",
      created_date: item?.created_date
        ? moment(item?.created_date).format("DD MMM YYYY")
        : "--",
      update_date: item?.update_date
        ? moment(item?.update_date).format("DD MMM YYYY")
        : "--",
      created_user_name: item?.created_user_name ?? "--",
      updated_user_name: item?.updated_user_name ?? "--",
      order_status: <BadgesComponent status={item?.pct_order_status} />,
      cmr_name: item?.cmr_name ?? "--",
      pct_total_amount: "₹ " + item?.pct_total_amount,
      itemData: item?.itemData?.length > 0 ? item?.itemData : [],
      is_draft_order: item?.is_draft_order,
      cmr_id: item?.cmr_id ?? "--",
      pct_order_status: item?.pct_order_status ?? "",
      is_voided: item?.is_voided ?? false,
      store_code: item?.store_code ?? "--",
      store_name: item?.store_name ?? "--",
      store_type: item?.store_type ?? "--",
      firm_name: item?.firm_name ?? "--",
      cmr_code: item?.cmr_code ?? "--",
      pct_reference_inv_number:item?.pct_reference_inv_number?? "--",
      pct_reference_inv_date: item?.pct_reference_inv_date? new Date(item.pct_reference_inv_date).toISOString().split("T")[0]: "--",
    };
  });

  const filterby = showFilter ? (
    <SalesPurchaseFilter
      filterData={filterData}
      setFilterData={setFilterData}
      setCurrentPage={setCurrentPage}
    />
  ) : null;
  const handleFilterClick = useCallback(() => {
    setShowFilter((prevShowFilter) => !prevShowFilter);
  }, []);

  const totalCreditNotes = billSummary?.totalCreditNotes ?? 0;
  const averageCreditNoteValue = billSummary?.averageCreditNoteValue ?? 0;
  const pendingCreditNotes = billSummary?.pendingCreditNotes ?? 0;
  const totalQuantityCredited = billSummary?.totalQuantityCredited ?? 0;

  const TransactionSummary = [
    {
      conClass:
        "bg-[var(--trans-stats-con-green-bg)] rounded-[12px] h-[5.3rem] w-[25%] p-3 flex justify-between",
      label: "Qty Claimed",
      value: totalQuantityCredited?.count ?? 0,
      desc: `₹${formatIndianNumber(
        totalQuantityCredited?.value || 0
      )} Credited`,
      descClass:
        "text-[length:var(--trans-stats-con-desc-fs)] font-[var(--trans-stats-con-desc-fw)] text-[var(--trans-stats-con-green-fg)]",
      icon: <MoveDownLeft size={16} color="var(--trans-stats-con-green-fg)" />,
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
    },
    {
      conClass:
        "bg-[var(--trans-stats-con-orange-bg)] rounded-[12px] h-[5.3rem] w-[25%] p-3 flex justify-between",
      label: "Avg. PCN Value",
      value: `₹ ${formatIndianNumber(averageCreditNoteValue?.value || 0)}`,
      desc: `${averageCreditNoteValue?.changePercentage < 0 ? "" : "+"}${
        averageCreditNoteValue?.changePercentage
      }% vs last week`,
      descClass:
        "text-[length:var(--trans-stats-con-desc-fs)] font-[var(--trans-stats-con-desc-fw)] text-[var(--trans-stats-con-orange-fg)]",
      icon: (
        <ChartColumnIncreasing
          size={16}
          color="var(--trans-stats-con-orange-fg)"
        />
      ),
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
    },
    {
      conClass:
        "bg-[var(--trans-stats-con-red-bg)] rounded-[12px] h-[5.3rem] w-[25%] p-3 flex justify-between",
      label: "Pending Adjustment",
      value: pendingCreditNotes?.count || 0,
      desc: `₹${formatIndianNumber(
        pendingCreditNotes?.value || 0
      )} yet to be claimed`,
      descClass:
        "text-[length:var(--trans-stats-con-desc-fs)] font-[var(--trans-stats-con-desc-fw)] text-[var(--trans-stats-con-red-fg)]",
      icon: <TimerIcon size={16} color="var(--trans-stats-con-red-fg)" />,
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
    },
    {
      conClass:
        "bg-[var(--trans-stats-con-blue-bg)] rounded-[12px] h-[5.3rem] w-[25%] p-3 flex justify-between",
      label: "Total PCNs Issued",
      value: totalCreditNotes?.count ?? 0,
      desc: `${totalCreditNotes?.changePercentage < 0 ? "" : "+"}${
        totalCreditNotes?.changePercentage
      } vs last Week`,
      descClass:
        "text-[length:var(--trans-stats-con-desc-fs)] font-[var(--trans-stats-con-desc-fw)] text-[var(--trans-stats-con-blue-fg)]",
      icon: <FileText size={16} color="var(--trans-stats-con-blue-fg)" />,
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
    },
  ];

  const summaryArray =
    TransactionSummary?.length > 0 ? (
      <div className="px-[24px] pt-[16px] flex gap-5">
        {TransactionSummary?.map((sum) => (
          <TransSummaryComp sum={sum} />
        ))}
      </div>
    ) : (
      <></>
    );

  return (
    <InnerLayout
      permissionFn={permissionFn}
      module="invoice"
      list={true}
      onclkFn={() => {
        navigate(
          `/add-purchase-credit/${encodeURIComponent(
            JSON.stringify([])
          )}/credit`
        );
      }}
      title="Purchase Credit Note"
    >
      {loading ? (
        <LoadingSpinner />
      ) : error ? (
        <></>
      ) : (
        <>
          <DynamicTransactionTable
            ViewAction={purchaseCreditViewAction}
            transaction="Purchase Credit Note"
            transaction_type="purchase_credit_note"
            setInvoiceItems={setInvoiceItems}
            invoiceItems={[]}
            options={[]}
            orders={orders}
            setOrders={setOrders}
            tableHeading1={tableHeading1}
            is_checkbox_req={true}
            onClickItemFn={(id) => navigate(`/view-purchase-credit/${id}`)}
            list={true}
            extraFilters={[
              { label: "Item Code", value: "item_code", column: true },
              { label: "Item Name", value: "item_name", column: true }
            ]}
            onclkFn={() => {
              navigate(
                `/add-purchase-credit/${encodeURIComponent(
                  JSON.stringify([])
                )}/credit?new`
              );
            }}
            cloneFn={(id) => {
              navigate(
                `/add-purchase-credit/${encodeURIComponent(
                  JSON.stringify([])
                )}/credit?cloneID=${id}`
              );
            }}
            permissionFn={permissionFn}
            module={"purchase_invoice"}
            path="purchase-credit"
            reload={reload}
            setReload={setReload}
            loading={loading}
            setLoading={setLoading}
            deleteAction={purchaseCreditVoidAction}
            label="Purchase Credit Note"
            showFilter={showFilter}
            filterFn={handleFilterClick}
            setFilterData={setFilterData}
            filterData={filterData}
            paginationProps={paginationProps}
            tableHeading={heading}
            tableBodyData={tableBodyData}
            placeholder="Search (/)"
            filterBy={filterby}
            initialFilter={{
              sort_by: "",
              sort_order: "",
              selectColumn: "pct_invoice_number",
              from: "",
              to: "",
              inputValue: "",
              orderStatus: "",
            }}
            transactionKey="pct"
            actionsPermissions={{
              edit: ["draft"], // Edit allowed for "open" and "draft"
              delete: ["open", "draft"], // Delete allowed only for "open"
              print: ["open", "closed", "draft"], // Print allowed for "open" and "closed"
              send: ["open", "closed", "draft"], // Share allowed for "open" and "closed"
              clone: ["open", "draft", "closed"], // Clone allowed for "open", "draft" and "closed"
            }}
            summaryArray={summaryArray}
          />
        </>
      )}
    </InnerLayout>
  );
};

export default PurchaseCreditTable;

const tableHeading = [
  {
    label: "Purchase Credit Note Number",
    value: "pct_invoice_number",
    display: true,
    column: true,
  },
  { label: "DATE", value: "update_date", display: true, column: false },
  {
    label: "ORDER STATUS",
    value: "order_status",
    display: false,
    column: false,
  },
  {
    label: "Customer Name",
    value: "cmr_name",
    display: true,
    column: true,
  },
  {
    label: <span className="flex justify-end">AMOUNT</span>,
    value: "pct_total_amount",
    display: true,
    column: false,
    className: "justify-end pe-5",
  },
  { label: "", value: "", column: false },
  // { label: "", value: "", column: false },
];

const tableHeading1 = [
  { label: "Product Name", value: "item_name" },
  { label: "Generic Name", value: "item_generic_name" },
  { label: "Item Code", value: "item_code" },
  { label: "UOM", value: "item_uom" },
  { label: "Price (₹)", value: "item_unit_price" },
  { label: "Qty", value: "item_quantity" },
  { label: "Total (₹)", value: "item_total_amount" },
];
